// extracted by mini-css-extract-plugin
export default {"colorDarkPurp":"Privacy_colorDarkPurp__6ZhW4","privacy_policy":"Privacy_privacy_policy__RRZch"};